// extracted by mini-css-extract-plugin
export default {"zoomModal":"I1-z","image":"J1-z","button":"K1-z","isOverlayShown":"L1-z"};